import React from 'react';
import { CheckCircle2Icon } from 'lucide-react';
import { advantages } from '../data/content';
import { toneAt } from '../utils/iconTones';
import { Accent, SectionHeading } from './SectionHeading';
import { Reveal } from './Reveal';
export function AdvantagesSection() {
  return <section className="w-full bg-steel-950 px-6 py-16 sm:py-20" aria-labelledby="why-title" data-id="element-1" data-mp="d45x43koe7nt">
      <div className="mx-auto max-w-5xl" data-id="element-2" data-mp="i38ssxern1j4">
        <SectionHeading id="why-title" badge="Why IIIS 2026" badgeIcon={CheckCircle2Icon} title={<>
              Built for the <Accent data-id="element-4" data-mp="m3auv7oexwyx">modern technical workforce</Accent>
            </>} data-id="element-3" data-mp="i27femaa22y8" />

        <ul className="mt-10 grid gap-3 sm:grid-cols-2" data-id="element-5" data-mp="qwlvus6jnjix">
          {advantages.map(({
          icon: Icon,
          title,
          description
        }, index) => <Reveal as="li" key={title} index={index} className="h-full" data-id="element-6" data-mp="10tqkqzrrxt3f" data-mpi={index}>
              <div className="flex h-full items-start gap-4 border border-white/[0.07] bg-steel-900 p-5" data-id="element-7" data-mp="10vl5oe31pl7i">
                <span className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-sm ${toneAt(index).bg}`} data-id="element-8" data-mp="15qqrze0d11w4">
                  <Icon className={`h-5 w-5 ${toneAt(index).fg}`} aria-hidden="true" data-id="element-9" data-mp="atm2z4z8c69b" />
                </span>
                <div data-id="element-10" data-mp="5u9e6eossp43">
                  <h3 className="font-display text-lg font-semibold uppercase tracking-wide text-ink-50" data-id="element-11" data-mp="5vkj4htzc2ws">
                    {title}
                  </h3>
                  <p className="mt-1.5 text-sm leading-relaxed text-ink-400" data-id="element-12" data-mp="1vab6zmmn2fa">{description}</p>
                </div>
              </div>
            </Reveal>)}
        </ul>
      </div>
    </section>;
}